// extracted by mini-css-extract-plugin
export var divider = "_yn-0";